
let USD = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});

function shortenedName(name, max_length = 32) {
    const split_point = max_length / 2;
    if(name.length > max_length) {
        return name.slice(0, max_length-split_point) + "..." + name.slice(-split_point + 3)
    }
    return name
}

function capitalized(text) {
    if(text.length < 2) {
        return text.toUpperCase();
    }
    return text.charAt(0).toUpperCase() + text.slice(1).replace("_", " ");
}

function formatPhone(phone) {
    var cleaned = ('' + phone).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return phone;
}


function formatCurrency(str) {
    if (str === "") {
      return "";
    }
    let parsed = parseFloat(str);
    if (!parsed) {
      return str;
    }
    return USD.format(parsed);
}
  

function contextFormat(text, key){
    if(key.includes("cost") || key.includes("price")) {
      return formatCurrency(text);
    }
    if(parseFloat(text)) {
      if(parseFloat(text) === parseInt(text))
        return `${parseInt(text)}`
      return `${parseFloat(text).toFixed(3)}`
    }
    return text;
}
  

function maybeFormatCurrency(key, str) {
    if (str === "") {
      return "";
    }
    let parsed = parseFloat(str);
    if (!parsed) {
      return str;
    }
    // currency for keys with "price" in key
    let klower = key.toLowerCase();
    if (klower.includes("price") || klower.includes("cost")) {
      return USD.format(parsed);
    }
    let twodecim = parsed.toFixed(2)
    return `${twodecim}`
}

export { shortenedName, capitalized, formatPhone, formatCurrency, contextFormat, maybeFormatCurrency };